import {BufferWriter, Writer} from "protobufjs";
import {IApiClient} from "../client";
import {api, entity} from "../rpc/api";
import {getToken} from "./bind_token";

class ClientConsultationAPI {
    constructor(readonly apiClient: IApiClient) {
    }

    public send(title: string, params: api.SendConsultationRequest.Item[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: api.SendConsultationRequest = new api.SendConsultationRequest();
                    req.title = title;
                    req.items = params;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken(
                        "/api.ClientConsultationService/Send",
                        token,
                        api.SendConsultationRequest.encode(req, writer).finish()
                    );
                })
                .then((binary: Uint8Array): void => {
                    resolve();
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        });
    }
}

const createClientConsultationAPI = (
    apiClient: IApiClient
): ClientConsultationAPI => {
    return new ClientConsultationAPI(apiClient);
};

export {createClientConsultationAPI};



// WEBPACK FOOTER //
// ./src/infra/api/service/client_consultation.ts